var _svg;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// This file is automatically generated from generateIllustrations.js
import * as React from 'react';
import IllustrationContainer from '../IllustrationContainer.js';

function BarGraphIllustration(props) {
  return /*#__PURE__*/React.createElement(IllustrationContainer, _extends({}, props, {
    children: _svg || (_svg = /*#__PURE__*/React.createElement("svg", {
      width: "100%",
      height: "100%",
      viewBox: "0 0 128 128",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React.createElement("g", {
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M25.495 89.928H4.992a2 2 0 00-2 2v13.658a2 2 0 002 2h20.503a2 2 0 002-2V91.928a2 2 0 00-2-2zM58.33 66.318H37.827a2 2 0 00-2 2v37.268a2 2 0 002 2H58.33a2 2 0 002-2V68.318a2 2 0 00-2-2zM91.165 42.61H70.662a2 2 0 00-2 2v60.976a2 2 0 002 2h20.502a2 2 0 002-2V44.61a2 2 0 00-2-2z",
      stroke: "currentColor",
      strokeMiterlimit: 10
    }), /*#__PURE__*/React.createElement("path", {
      d: "M103.498 20.5H124a.5.5 0 01.5.5v84.586a.5.5 0 01-.5.5h-20.502a.5.5 0 01-.5-.5V21a.5.5 0 01.5-.5z",
      fill: "#009CEB",
      stroke: "#009CEB"
    }))))
  }));
}

export default BarGraphIllustration;